import { render, staticRenderFns } from "./superBHot.vue?vue&type=template&id=03c836a0&"
import script from "./superBHot.vue?vue&type=script&lang=js&"
export * from "./superBHot.vue?vue&type=script&lang=js&"
import style0 from "./superBHot.vue?vue&type=style&index=0&id=03c836a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports